// source: asset/snapshot.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var asset_util_pb = require('../asset/util_pb.js');
goog.object.extend(proto, asset_util_pb);
var asset_task_pb = require('../asset/task_pb.js');
goog.object.extend(proto, asset_task_pb);
var asset_network_pb = require('../asset/network_pb.js');
goog.object.extend(proto, asset_network_pb);
goog.exportSymbol('proto.asset.Address', null, global);
goog.exportSymbol('proto.asset.ExtraField', null, global);
goog.exportSymbol('proto.asset.ExtraField.BIOS', null, global);
goog.exportSymbol('proto.asset.ExtraField.CPU', null, global);
goog.exportSymbol('proto.asset.ExtraField.CPU.Model', null, global);
goog.exportSymbol('proto.asset.ExtraField.Kernel', null, global);
goog.exportSymbol('proto.asset.ExtraField.Memory', null, global);
goog.exportSymbol('proto.asset.ExtraField.Motherboard', null, global);
goog.exportSymbol('proto.asset.ExtraField.Networking', null, global);
goog.exportSymbol('proto.asset.ExtraField.Networking.DefaultGateway', null, global);
goog.exportSymbol('proto.asset.ExtraField.Product', null, global);
goog.exportSymbol('proto.asset.ExtraField.Storage', null, global);
goog.exportSymbol('proto.asset.ExtraField.Windows', null, global);
goog.exportSymbol('proto.asset.GetListSnapshotNodeRequest', null, global);
goog.exportSymbol('proto.asset.GetListSnapshotRequest', null, global);
goog.exportSymbol('proto.asset.Interface', null, global);
goog.exportSymbol('proto.asset.Node', null, global);
goog.exportSymbol('proto.asset.Package', null, global);
goog.exportSymbol('proto.asset.Snapshot', null, global);
goog.exportSymbol('proto.asset.SnapshotListResponse', null, global);
goog.exportSymbol('proto.asset.SnapshotNodeListResponse', null, global);
goog.exportSymbol('proto.asset.SnapshotNodePackageListResponse', null, global);
goog.exportSymbol('proto.asset.SnapshotNodeRequest', null, global);
goog.exportSymbol('proto.asset.SnapshotNodeResponse', null, global);
goog.exportSymbol('proto.asset.SnapshotNodeWindowsUpdateListResponse', null, global);
goog.exportSymbol('proto.asset.SnapshotRequest', null, global);
goog.exportSymbol('proto.asset.SnapshotResponse', null, global);
goog.exportSymbol('proto.asset.System', null, global);
goog.exportSymbol('proto.asset.WindowsUpdate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Snapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Snapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Snapshot.displayName = 'proto.asset.Snapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Address.displayName = 'proto.asset.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Interface = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Interface, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Interface.displayName = 'proto.asset.Interface';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.System = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.System, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.System.displayName = 'proto.asset.System';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.displayName = 'proto.asset.ExtraField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.BIOS = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.BIOS, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.BIOS.displayName = 'proto.asset.ExtraField.BIOS';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Motherboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Motherboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Motherboard.displayName = 'proto.asset.ExtraField.Motherboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Product.displayName = 'proto.asset.ExtraField.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.CPU = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.ExtraField.CPU.repeatedFields_, null);
};
goog.inherits(proto.asset.ExtraField.CPU, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.CPU.displayName = 'proto.asset.ExtraField.CPU';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.CPU.Model = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.CPU.Model, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.CPU.Model.displayName = 'proto.asset.ExtraField.CPU.Model';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Memory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Memory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Memory.displayName = 'proto.asset.ExtraField.Memory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Storage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Storage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Storage.displayName = 'proto.asset.ExtraField.Storage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Networking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.ExtraField.Networking.repeatedFields_, null);
};
goog.inherits(proto.asset.ExtraField.Networking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Networking.displayName = 'proto.asset.ExtraField.Networking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Networking.DefaultGateway = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Networking.DefaultGateway, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Networking.DefaultGateway.displayName = 'proto.asset.ExtraField.Networking.DefaultGateway';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Kernel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Kernel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Kernel.displayName = 'proto.asset.ExtraField.Kernel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.ExtraField.Windows = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.ExtraField.Windows, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.ExtraField.Windows.displayName = 'proto.asset.ExtraField.Windows';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Node = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.Node.repeatedFields_, null);
};
goog.inherits(proto.asset.Node, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Node.displayName = 'proto.asset.Node';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Package = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Package, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Package.displayName = 'proto.asset.Package';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.WindowsUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.WindowsUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.WindowsUpdate.displayName = 'proto.asset.WindowsUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.SnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotRequest.displayName = 'proto.asset.SnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.GetListSnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.GetListSnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.GetListSnapshotRequest.displayName = 'proto.asset.GetListSnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotNodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.SnapshotNodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotNodeRequest.displayName = 'proto.asset.SnapshotNodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.GetListSnapshotNodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.GetListSnapshotNodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.GetListSnapshotNodeRequest.displayName = 'proto.asset.GetListSnapshotNodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.SnapshotListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.SnapshotListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotListResponse.displayName = 'proto.asset.SnapshotListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.SnapshotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotResponse.displayName = 'proto.asset.SnapshotResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotNodeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.SnapshotNodeListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.SnapshotNodeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotNodeListResponse.displayName = 'proto.asset.SnapshotNodeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotNodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.SnapshotNodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotNodeResponse.displayName = 'proto.asset.SnapshotNodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotNodePackageListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.SnapshotNodePackageListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.SnapshotNodePackageListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotNodePackageListResponse.displayName = 'proto.asset.SnapshotNodePackageListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.SnapshotNodeWindowsUpdateListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.SnapshotNodeWindowsUpdateListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.SnapshotNodeWindowsUpdateListResponse.displayName = 'proto.asset.SnapshotNodeWindowsUpdateListResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Snapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Snapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Snapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Snapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskId: jspb.Message.getFieldWithDefault(msg, 2, ""),
startedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
terminatedAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
numberOfNode: jspb.Message.getFieldWithDefault(msg, 5, 0),
numberOfAddress: jspb.Message.getFieldWithDefault(msg, 6, 0),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
scanTotalTime: jspb.Message.getFieldWithDefault(msg, 10, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
vSensorName: jspb.Message.getFieldWithDefault(msg, 12, ""),
networkConfig: (f = msg.getNetworkConfig()) && asset_task_pb.NetworkConfig.toObject(includeInstance, f),
numberOfAddressAggregations: jspb.Message.getFieldWithDefault(msg, 15, 0),
numberOfNicAggregations: jspb.Message.getFieldWithDefault(msg, 16, 0),
numberOfNodeAggregations: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Snapshot}
 */
proto.asset.Snapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Snapshot;
  return proto.asset.Snapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Snapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Snapshot}
 */
proto.asset.Snapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTerminatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfNode(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfAddress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScanTotalTime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setVSensorName(value);
      break;
    case 13:
      var value = new asset_task_pb.NetworkConfig;
      reader.readMessage(value,asset_task_pb.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfAddressAggregations(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfNicAggregations(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfNodeAggregations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Snapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Snapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Snapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Snapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTerminatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getNumberOfNode();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNumberOfAddress();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getScanTotalTime();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getVSensorName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      asset_task_pb.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfAddressAggregations();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getNumberOfNicAggregations();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getNumberOfNodeAggregations();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.asset.Snapshot.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.asset.Snapshot.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 started_at = 3;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 terminated_at = 4;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getTerminatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setTerminatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 number_of_node = 5;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getNumberOfNode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setNumberOfNode = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 number_of_address = 6;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getNumberOfAddress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setNumberOfAddress = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.asset.Snapshot.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 scan_total_time = 10;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getScanTotalTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setScanTotalTime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string v_sensor_name = 12;
 * @return {string}
 */
proto.asset.Snapshot.prototype.getVSensorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setVSensorName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional NetworkConfig network_config = 13;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.Snapshot.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, asset_task_pb.NetworkConfig, 13));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.Snapshot} returns this
*/
proto.asset.Snapshot.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.Snapshot.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 number_of_address_aggregations = 15;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getNumberOfAddressAggregations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setNumberOfAddressAggregations = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 number_of_nic_aggregations = 16;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getNumberOfNicAggregations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setNumberOfNicAggregations = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 number_of_node_aggregations = 17;
 * @return {number}
 */
proto.asset.Snapshot.prototype.getNumberOfNodeAggregations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Snapshot} returns this
 */
proto.asset.Snapshot.prototype.setNumberOfNodeAggregations = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 3, ""),
addr: jspb.Message.getFieldWithDefault(msg, 5, ""),
subnet: jspb.Message.getFieldWithDefault(msg, 6, ""),
macaddr: jspb.Message.getFieldWithDefault(msg, 7, ""),
hostname: jspb.Message.getFieldWithDefault(msg, 8, ""),
macaddrOrganizationName: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Address}
 */
proto.asset.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Address;
  return proto.asset.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Address}
 */
proto.asset.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubnet(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacaddr(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacaddrOrganizationName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubnet();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMacaddr();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHostname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMacaddrOrganizationName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.asset.Address.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string addr = 5;
 * @return {string}
 */
proto.asset.Address.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subnet = 6;
 * @return {string}
 */
proto.asset.Address.prototype.getSubnet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setSubnet = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string macaddr = 7;
 * @return {string}
 */
proto.asset.Address.prototype.getMacaddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setMacaddr = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string hostname = 8;
 * @return {string}
 */
proto.asset.Address.prototype.getHostname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setHostname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string macaddr_organization_name = 9;
 * @return {string}
 */
proto.asset.Address.prototype.getMacaddrOrganizationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Address} returns this
 */
proto.asset.Address.prototype.setMacaddrOrganizationName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Interface.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Interface.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Interface} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Interface.toObject = function(includeInstance, msg) {
  var f, obj = {
ifname: jspb.Message.getFieldWithDefault(msg, 1, ""),
addr: jspb.Message.getFieldWithDefault(msg, 2, ""),
macaddr: jspb.Message.getFieldWithDefault(msg, 3, ""),
netmask: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Interface}
 */
proto.asset.Interface.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Interface;
  return proto.asset.Interface.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Interface} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Interface}
 */
proto.asset.Interface.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIfname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacaddr(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetmask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Interface.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Interface.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Interface} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Interface.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIfname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMacaddr();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNetmask();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string ifname = 1;
 * @return {string}
 */
proto.asset.Interface.prototype.getIfname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Interface} returns this
 */
proto.asset.Interface.prototype.setIfname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string addr = 2;
 * @return {string}
 */
proto.asset.Interface.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Interface} returns this
 */
proto.asset.Interface.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string macaddr = 3;
 * @return {string}
 */
proto.asset.Interface.prototype.getMacaddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Interface} returns this
 */
proto.asset.Interface.prototype.setMacaddr = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string netmask = 4;
 * @return {string}
 */
proto.asset.Interface.prototype.getNetmask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Interface} returns this
 */
proto.asset.Interface.prototype.setNetmask = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.System.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.System.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.System} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.System.toObject = function(includeInstance, msg) {
  var f, obj = {
family: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
serial: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.System}
 */
proto.asset.System.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.System;
  return proto.asset.System.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.System} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.System}
 */
proto.asset.System.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamily(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.System.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.System.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.System} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.System.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFamily();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string family = 1;
 * @return {string}
 */
proto.asset.System.prototype.getFamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.System} returns this
 */
proto.asset.System.prototype.setFamily = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.asset.System.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.System} returns this
 */
proto.asset.System.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string serial = 3;
 * @return {string}
 */
proto.asset.System.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.System} returns this
 */
proto.asset.System.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.toObject = function(includeInstance, msg) {
  var f, obj = {
bios: (f = msg.getBios()) && proto.asset.ExtraField.BIOS.toObject(includeInstance, f),
motherboard: (f = msg.getMotherboard()) && proto.asset.ExtraField.Motherboard.toObject(includeInstance, f),
product: (f = msg.getProduct()) && proto.asset.ExtraField.Product.toObject(includeInstance, f),
cpu: (f = msg.getCpu()) && proto.asset.ExtraField.CPU.toObject(includeInstance, f),
memory: (f = msg.getMemory()) && proto.asset.ExtraField.Memory.toObject(includeInstance, f),
storage: (f = msg.getStorage()) && proto.asset.ExtraField.Storage.toObject(includeInstance, f),
networking: (f = msg.getNetworking()) && proto.asset.ExtraField.Networking.toObject(includeInstance, f),
kernel: (f = msg.getKernel()) && proto.asset.ExtraField.Kernel.toObject(includeInstance, f),
windows: (f = msg.getWindows()) && proto.asset.ExtraField.Windows.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField}
 */
proto.asset.ExtraField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField;
  return proto.asset.ExtraField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField}
 */
proto.asset.ExtraField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.ExtraField.BIOS;
      reader.readMessage(value,proto.asset.ExtraField.BIOS.deserializeBinaryFromReader);
      msg.setBios(value);
      break;
    case 2:
      var value = new proto.asset.ExtraField.Motherboard;
      reader.readMessage(value,proto.asset.ExtraField.Motherboard.deserializeBinaryFromReader);
      msg.setMotherboard(value);
      break;
    case 3:
      var value = new proto.asset.ExtraField.Product;
      reader.readMessage(value,proto.asset.ExtraField.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 4:
      var value = new proto.asset.ExtraField.CPU;
      reader.readMessage(value,proto.asset.ExtraField.CPU.deserializeBinaryFromReader);
      msg.setCpu(value);
      break;
    case 5:
      var value = new proto.asset.ExtraField.Memory;
      reader.readMessage(value,proto.asset.ExtraField.Memory.deserializeBinaryFromReader);
      msg.setMemory(value);
      break;
    case 6:
      var value = new proto.asset.ExtraField.Storage;
      reader.readMessage(value,proto.asset.ExtraField.Storage.deserializeBinaryFromReader);
      msg.setStorage(value);
      break;
    case 7:
      var value = new proto.asset.ExtraField.Networking;
      reader.readMessage(value,proto.asset.ExtraField.Networking.deserializeBinaryFromReader);
      msg.setNetworking(value);
      break;
    case 8:
      var value = new proto.asset.ExtraField.Kernel;
      reader.readMessage(value,proto.asset.ExtraField.Kernel.deserializeBinaryFromReader);
      msg.setKernel(value);
      break;
    case 9:
      var value = new proto.asset.ExtraField.Windows;
      reader.readMessage(value,proto.asset.ExtraField.Windows.deserializeBinaryFromReader);
      msg.setWindows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBios();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.ExtraField.BIOS.serializeBinaryToWriter
    );
  }
  f = message.getMotherboard();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.asset.ExtraField.Motherboard.serializeBinaryToWriter
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.asset.ExtraField.Product.serializeBinaryToWriter
    );
  }
  f = message.getCpu();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.asset.ExtraField.CPU.serializeBinaryToWriter
    );
  }
  f = message.getMemory();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.asset.ExtraField.Memory.serializeBinaryToWriter
    );
  }
  f = message.getStorage();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.ExtraField.Storage.serializeBinaryToWriter
    );
  }
  f = message.getNetworking();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.asset.ExtraField.Networking.serializeBinaryToWriter
    );
  }
  f = message.getKernel();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.asset.ExtraField.Kernel.serializeBinaryToWriter
    );
  }
  f = message.getWindows();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.asset.ExtraField.Windows.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.BIOS.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.BIOS.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.BIOS} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.BIOS.toObject = function(includeInstance, msg) {
  var f, obj = {
vendorName: jspb.Message.getFieldWithDefault(msg, 1, ""),
versionNumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.BIOS}
 */
proto.asset.ExtraField.BIOS.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.BIOS;
  return proto.asset.ExtraField.BIOS.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.BIOS} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.BIOS}
 */
proto.asset.ExtraField.BIOS.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.BIOS.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.BIOS.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.BIOS} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.BIOS.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersionNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string vendor_name = 1;
 * @return {string}
 */
proto.asset.ExtraField.BIOS.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.BIOS} returns this
 */
proto.asset.ExtraField.BIOS.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version_number = 2;
 * @return {string}
 */
proto.asset.ExtraField.BIOS.prototype.getVersionNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.BIOS} returns this
 */
proto.asset.ExtraField.BIOS.prototype.setVersionNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Motherboard.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Motherboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Motherboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Motherboard.toObject = function(includeInstance, msg) {
  var f, obj = {
vendorName: jspb.Message.getFieldWithDefault(msg, 1, ""),
modelNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
versionNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
serialNumber: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Motherboard}
 */
proto.asset.ExtraField.Motherboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Motherboard;
  return proto.asset.ExtraField.Motherboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Motherboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Motherboard}
 */
proto.asset.ExtraField.Motherboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Motherboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Motherboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Motherboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Motherboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersionNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSerialNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string vendor_name = 1;
 * @return {string}
 */
proto.asset.ExtraField.Motherboard.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Motherboard} returns this
 */
proto.asset.ExtraField.Motherboard.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_number = 2;
 * @return {string}
 */
proto.asset.ExtraField.Motherboard.prototype.getModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Motherboard} returns this
 */
proto.asset.ExtraField.Motherboard.prototype.setModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string version_number = 3;
 * @return {string}
 */
proto.asset.ExtraField.Motherboard.prototype.getVersionNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Motherboard} returns this
 */
proto.asset.ExtraField.Motherboard.prototype.setVersionNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string serial_number = 4;
 * @return {string}
 */
proto.asset.ExtraField.Motherboard.prototype.getSerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Motherboard} returns this
 */
proto.asset.ExtraField.Motherboard.prototype.setSerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
modelNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
modelName: jspb.Message.getFieldWithDefault(msg, 2, ""),
serialNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
versionNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
firmwareVersionNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
vendorName: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Product}
 */
proto.asset.ExtraField.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Product;
  return proto.asset.ExtraField.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Product}
 */
proto.asset.ExtraField.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersionNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSerialNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersionNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirmwareVersionNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string model_number = 1;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_name = 2;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string serial_number = 3;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getSerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setSerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string version_number = 4;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getVersionNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setVersionNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string firmware_version_number = 5;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getFirmwareVersionNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setFirmwareVersionNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string vendor_name = 6;
 * @return {string}
 */
proto.asset.ExtraField.Product.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Product} returns this
 */
proto.asset.ExtraField.Product.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.ExtraField.CPU.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.CPU.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.CPU.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.CPU} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.CPU.toObject = function(includeInstance, msg) {
  var f, obj = {
numberOfSocket: jspb.Message.getFieldWithDefault(msg, 1, 0),
numberOfCore: jspb.Message.getFieldWithDefault(msg, 2, 0),
numberOfProcessor: jspb.Message.getFieldWithDefault(msg, 3, 0),
modelListList: jspb.Message.toObjectList(msg.getModelListList(),
    proto.asset.ExtraField.CPU.Model.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.CPU}
 */
proto.asset.ExtraField.CPU.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.CPU;
  return proto.asset.ExtraField.CPU.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.CPU} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.CPU}
 */
proto.asset.ExtraField.CPU.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfSocket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfCore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfProcessor(value);
      break;
    case 4:
      var value = new proto.asset.ExtraField.CPU.Model;
      reader.readMessage(value,proto.asset.ExtraField.CPU.Model.deserializeBinaryFromReader);
      msg.addModelList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.CPU.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.CPU.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.CPU} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.CPU.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfSocket();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNumberOfCore();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getNumberOfProcessor();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getModelListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.asset.ExtraField.CPU.Model.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.CPU.Model.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.CPU.Model.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.CPU.Model} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.CPU.Model.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
clockSpeed: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.CPU.Model}
 */
proto.asset.ExtraField.CPU.Model.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.CPU.Model;
  return proto.asset.ExtraField.CPU.Model.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.CPU.Model} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.CPU.Model}
 */
proto.asset.ExtraField.CPU.Model.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClockSpeed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.CPU.Model.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.CPU.Model.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.CPU.Model} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.CPU.Model.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClockSpeed();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.asset.ExtraField.CPU.Model.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.CPU.Model} returns this
 */
proto.asset.ExtraField.CPU.Model.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 clock_speed = 2;
 * @return {number}
 */
proto.asset.ExtraField.CPU.Model.prototype.getClockSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.CPU.Model} returns this
 */
proto.asset.ExtraField.CPU.Model.prototype.setClockSpeed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 number_of_socket = 1;
 * @return {number}
 */
proto.asset.ExtraField.CPU.prototype.getNumberOfSocket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.CPU} returns this
 */
proto.asset.ExtraField.CPU.prototype.setNumberOfSocket = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 number_of_core = 2;
 * @return {number}
 */
proto.asset.ExtraField.CPU.prototype.getNumberOfCore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.CPU} returns this
 */
proto.asset.ExtraField.CPU.prototype.setNumberOfCore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 number_of_processor = 3;
 * @return {number}
 */
proto.asset.ExtraField.CPU.prototype.getNumberOfProcessor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.CPU} returns this
 */
proto.asset.ExtraField.CPU.prototype.setNumberOfProcessor = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Model model_list = 4;
 * @return {!Array<!proto.asset.ExtraField.CPU.Model>}
 */
proto.asset.ExtraField.CPU.prototype.getModelListList = function() {
  return /** @type{!Array<!proto.asset.ExtraField.CPU.Model>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.ExtraField.CPU.Model, 4));
};


/**
 * @param {!Array<!proto.asset.ExtraField.CPU.Model>} value
 * @return {!proto.asset.ExtraField.CPU} returns this
*/
proto.asset.ExtraField.CPU.prototype.setModelListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.asset.ExtraField.CPU.Model=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.ExtraField.CPU.Model}
 */
proto.asset.ExtraField.CPU.prototype.addModelList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.asset.ExtraField.CPU.Model, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.ExtraField.CPU} returns this
 */
proto.asset.ExtraField.CPU.prototype.clearModelListList = function() {
  return this.setModelListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Memory.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Memory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Memory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Memory.toObject = function(includeInstance, msg) {
  var f, obj = {
totalSize: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Memory}
 */
proto.asset.ExtraField.Memory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Memory;
  return proto.asset.ExtraField.Memory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Memory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Memory}
 */
proto.asset.ExtraField.Memory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Memory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Memory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Memory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Memory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalSize();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 total_size = 1;
 * @return {number}
 */
proto.asset.ExtraField.Memory.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.Memory} returns this
 */
proto.asset.ExtraField.Memory.prototype.setTotalSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Storage.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Storage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Storage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Storage.toObject = function(includeInstance, msg) {
  var f, obj = {
numberOfDrives: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalSize: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Storage}
 */
proto.asset.ExtraField.Storage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Storage;
  return proto.asset.ExtraField.Storage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Storage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Storage}
 */
proto.asset.ExtraField.Storage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfDrives(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Storage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Storage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Storage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Storage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfDrives();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalSize();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 number_of_drives = 1;
 * @return {number}
 */
proto.asset.ExtraField.Storage.prototype.getNumberOfDrives = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.Storage} returns this
 */
proto.asset.ExtraField.Storage.prototype.setNumberOfDrives = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_size = 2;
 * @return {number}
 */
proto.asset.ExtraField.Storage.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.ExtraField.Storage} returns this
 */
proto.asset.ExtraField.Storage.prototype.setTotalSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.ExtraField.Networking.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Networking.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Networking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Networking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Networking.toObject = function(includeInstance, msg) {
  var f, obj = {
defaultGatewayListList: jspb.Message.toObjectList(msg.getDefaultGatewayListList(),
    proto.asset.ExtraField.Networking.DefaultGateway.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Networking}
 */
proto.asset.ExtraField.Networking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Networking;
  return proto.asset.ExtraField.Networking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Networking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Networking}
 */
proto.asset.ExtraField.Networking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.ExtraField.Networking.DefaultGateway;
      reader.readMessage(value,proto.asset.ExtraField.Networking.DefaultGateway.deserializeBinaryFromReader);
      msg.addDefaultGatewayList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Networking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Networking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Networking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Networking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDefaultGatewayListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.asset.ExtraField.Networking.DefaultGateway.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Networking.DefaultGateway.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Networking.DefaultGateway} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Networking.DefaultGateway.toObject = function(includeInstance, msg) {
  var f, obj = {
addr: jspb.Message.getFieldWithDefault(msg, 1, ""),
interfaceName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Networking.DefaultGateway}
 */
proto.asset.ExtraField.Networking.DefaultGateway.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Networking.DefaultGateway;
  return proto.asset.ExtraField.Networking.DefaultGateway.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Networking.DefaultGateway} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Networking.DefaultGateway}
 */
proto.asset.ExtraField.Networking.DefaultGateway.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterfaceName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Networking.DefaultGateway.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Networking.DefaultGateway} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Networking.DefaultGateway.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterfaceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string addr = 1;
 * @return {string}
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Networking.DefaultGateway} returns this
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string interface_name = 2;
 * @return {string}
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.getInterfaceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Networking.DefaultGateway} returns this
 */
proto.asset.ExtraField.Networking.DefaultGateway.prototype.setInterfaceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DefaultGateway default_gateway_list = 1;
 * @return {!Array<!proto.asset.ExtraField.Networking.DefaultGateway>}
 */
proto.asset.ExtraField.Networking.prototype.getDefaultGatewayListList = function() {
  return /** @type{!Array<!proto.asset.ExtraField.Networking.DefaultGateway>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.ExtraField.Networking.DefaultGateway, 1));
};


/**
 * @param {!Array<!proto.asset.ExtraField.Networking.DefaultGateway>} value
 * @return {!proto.asset.ExtraField.Networking} returns this
*/
proto.asset.ExtraField.Networking.prototype.setDefaultGatewayListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.asset.ExtraField.Networking.DefaultGateway=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.ExtraField.Networking.DefaultGateway}
 */
proto.asset.ExtraField.Networking.prototype.addDefaultGatewayList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.asset.ExtraField.Networking.DefaultGateway, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.ExtraField.Networking} returns this
 */
proto.asset.ExtraField.Networking.prototype.clearDefaultGatewayListList = function() {
  return this.setDefaultGatewayListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Kernel.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Kernel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Kernel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Kernel.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
release: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Kernel}
 */
proto.asset.ExtraField.Kernel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Kernel;
  return proto.asset.ExtraField.Kernel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Kernel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Kernel}
 */
proto.asset.ExtraField.Kernel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelease(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Kernel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Kernel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Kernel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Kernel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRelease();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.asset.ExtraField.Kernel.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Kernel} returns this
 */
proto.asset.ExtraField.Kernel.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.asset.ExtraField.Kernel.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Kernel} returns this
 */
proto.asset.ExtraField.Kernel.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string release = 3;
 * @return {string}
 */
proto.asset.ExtraField.Kernel.prototype.getRelease = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Kernel} returns this
 */
proto.asset.ExtraField.Kernel.prototype.setRelease = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.ExtraField.Windows.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.ExtraField.Windows.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.ExtraField.Windows} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Windows.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, ""),
osBuild: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.ExtraField.Windows}
 */
proto.asset.ExtraField.Windows.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.ExtraField.Windows;
  return proto.asset.ExtraField.Windows.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.ExtraField.Windows} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.ExtraField.Windows}
 */
proto.asset.ExtraField.Windows.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsBuild(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.ExtraField.Windows.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.ExtraField.Windows.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.ExtraField.Windows} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.ExtraField.Windows.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOsBuild();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.asset.ExtraField.Windows.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Windows} returns this
 */
proto.asset.ExtraField.Windows.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string os_build = 2;
 * @return {string}
 */
proto.asset.ExtraField.Windows.prototype.getOsBuild = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.ExtraField.Windows} returns this
 */
proto.asset.ExtraField.Windows.prototype.setOsBuild = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BIOS bios = 1;
 * @return {?proto.asset.ExtraField.BIOS}
 */
proto.asset.ExtraField.prototype.getBios = function() {
  return /** @type{?proto.asset.ExtraField.BIOS} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.BIOS, 1));
};


/**
 * @param {?proto.asset.ExtraField.BIOS|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setBios = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearBios = function() {
  return this.setBios(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasBios = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Motherboard motherboard = 2;
 * @return {?proto.asset.ExtraField.Motherboard}
 */
proto.asset.ExtraField.prototype.getMotherboard = function() {
  return /** @type{?proto.asset.ExtraField.Motherboard} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Motherboard, 2));
};


/**
 * @param {?proto.asset.ExtraField.Motherboard|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setMotherboard = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearMotherboard = function() {
  return this.setMotherboard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasMotherboard = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Product product = 3;
 * @return {?proto.asset.ExtraField.Product}
 */
proto.asset.ExtraField.prototype.getProduct = function() {
  return /** @type{?proto.asset.ExtraField.Product} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Product, 3));
};


/**
 * @param {?proto.asset.ExtraField.Product|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CPU cpu = 4;
 * @return {?proto.asset.ExtraField.CPU}
 */
proto.asset.ExtraField.prototype.getCpu = function() {
  return /** @type{?proto.asset.ExtraField.CPU} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.CPU, 4));
};


/**
 * @param {?proto.asset.ExtraField.CPU|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setCpu = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearCpu = function() {
  return this.setCpu(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasCpu = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Memory memory = 5;
 * @return {?proto.asset.ExtraField.Memory}
 */
proto.asset.ExtraField.prototype.getMemory = function() {
  return /** @type{?proto.asset.ExtraField.Memory} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Memory, 5));
};


/**
 * @param {?proto.asset.ExtraField.Memory|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setMemory = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearMemory = function() {
  return this.setMemory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasMemory = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Storage storage = 6;
 * @return {?proto.asset.ExtraField.Storage}
 */
proto.asset.ExtraField.prototype.getStorage = function() {
  return /** @type{?proto.asset.ExtraField.Storage} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Storage, 6));
};


/**
 * @param {?proto.asset.ExtraField.Storage|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setStorage = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearStorage = function() {
  return this.setStorage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasStorage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Networking networking = 7;
 * @return {?proto.asset.ExtraField.Networking}
 */
proto.asset.ExtraField.prototype.getNetworking = function() {
  return /** @type{?proto.asset.ExtraField.Networking} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Networking, 7));
};


/**
 * @param {?proto.asset.ExtraField.Networking|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setNetworking = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearNetworking = function() {
  return this.setNetworking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasNetworking = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Kernel kernel = 8;
 * @return {?proto.asset.ExtraField.Kernel}
 */
proto.asset.ExtraField.prototype.getKernel = function() {
  return /** @type{?proto.asset.ExtraField.Kernel} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Kernel, 8));
};


/**
 * @param {?proto.asset.ExtraField.Kernel|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setKernel = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearKernel = function() {
  return this.setKernel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasKernel = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Windows windows = 9;
 * @return {?proto.asset.ExtraField.Windows}
 */
proto.asset.ExtraField.prototype.getWindows = function() {
  return /** @type{?proto.asset.ExtraField.Windows} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField.Windows, 9));
};


/**
 * @param {?proto.asset.ExtraField.Windows|undefined} value
 * @return {!proto.asset.ExtraField} returns this
*/
proto.asset.ExtraField.prototype.setWindows = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.ExtraField} returns this
 */
proto.asset.ExtraField.prototype.clearWindows = function() {
  return this.setWindows(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.ExtraField.prototype.hasWindows = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.Node.repeatedFields_ = [4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Node.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Node.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Node} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Node.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 3, ""),
addressListList: jspb.Message.toObjectList(msg.getAddressListList(),
    proto.asset.Address.toObject, includeInstance),
aggregationType: jspb.Message.getFieldWithDefault(msg, 5, ""),
system: (f = msg.getSystem()) && proto.asset.System.toObject(includeInstance, f),
interfaceListList: jspb.Message.toObjectList(msg.getInterfaceListList(),
    proto.asset.Interface.toObject, includeInstance),
numberOfPackage: jspb.Message.getFieldWithDefault(msg, 8, 0),
numberOfWindowsUpdate: jspb.Message.getFieldWithDefault(msg, 9, 0),
extraField: (f = msg.getExtraField()) && proto.asset.ExtraField.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Node}
 */
proto.asset.Node.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Node;
  return proto.asset.Node.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Node} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Node}
 */
proto.asset.Node.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = new proto.asset.Address;
      reader.readMessage(value,proto.asset.Address.deserializeBinaryFromReader);
      msg.addAddressList(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAggregationType(value);
      break;
    case 6:
      var value = new proto.asset.System;
      reader.readMessage(value,proto.asset.System.deserializeBinaryFromReader);
      msg.setSystem(value);
      break;
    case 7:
      var value = new proto.asset.Interface;
      reader.readMessage(value,proto.asset.Interface.deserializeBinaryFromReader);
      msg.addInterfaceList(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfPackage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfWindowsUpdate(value);
      break;
    case 10:
      var value = new proto.asset.ExtraField;
      reader.readMessage(value,proto.asset.ExtraField.deserializeBinaryFromReader);
      msg.setExtraField(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Node.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Node.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Node} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Node.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddressListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.asset.Address.serializeBinaryToWriter
    );
  }
  f = message.getAggregationType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSystem();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.System.serializeBinaryToWriter
    );
  }
  f = message.getInterfaceListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.asset.Interface.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfPackage();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getNumberOfWindowsUpdate();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getExtraField();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.asset.ExtraField.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.asset.Node.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Address address_list = 4;
 * @return {!Array<!proto.asset.Address>}
 */
proto.asset.Node.prototype.getAddressListList = function() {
  return /** @type{!Array<!proto.asset.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Address, 4));
};


/**
 * @param {!Array<!proto.asset.Address>} value
 * @return {!proto.asset.Node} returns this
*/
proto.asset.Node.prototype.setAddressListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.asset.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Address}
 */
proto.asset.Node.prototype.addAddressList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.asset.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.clearAddressListList = function() {
  return this.setAddressListList([]);
};


/**
 * optional string aggregation_type = 5;
 * @return {string}
 */
proto.asset.Node.prototype.getAggregationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.setAggregationType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional System system = 6;
 * @return {?proto.asset.System}
 */
proto.asset.Node.prototype.getSystem = function() {
  return /** @type{?proto.asset.System} */ (
    jspb.Message.getWrapperField(this, proto.asset.System, 6));
};


/**
 * @param {?proto.asset.System|undefined} value
 * @return {!proto.asset.Node} returns this
*/
proto.asset.Node.prototype.setSystem = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.clearSystem = function() {
  return this.setSystem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.Node.prototype.hasSystem = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Interface interface_list = 7;
 * @return {!Array<!proto.asset.Interface>}
 */
proto.asset.Node.prototype.getInterfaceListList = function() {
  return /** @type{!Array<!proto.asset.Interface>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Interface, 7));
};


/**
 * @param {!Array<!proto.asset.Interface>} value
 * @return {!proto.asset.Node} returns this
*/
proto.asset.Node.prototype.setInterfaceListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.asset.Interface=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Interface}
 */
proto.asset.Node.prototype.addInterfaceList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.asset.Interface, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.clearInterfaceListList = function() {
  return this.setInterfaceListList([]);
};


/**
 * optional int32 number_of_package = 8;
 * @return {number}
 */
proto.asset.Node.prototype.getNumberOfPackage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.setNumberOfPackage = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 number_of_windows_update = 9;
 * @return {number}
 */
proto.asset.Node.prototype.getNumberOfWindowsUpdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.setNumberOfWindowsUpdate = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional ExtraField extra_field = 10;
 * @return {?proto.asset.ExtraField}
 */
proto.asset.Node.prototype.getExtraField = function() {
  return /** @type{?proto.asset.ExtraField} */ (
    jspb.Message.getWrapperField(this, proto.asset.ExtraField, 10));
};


/**
 * @param {?proto.asset.ExtraField|undefined} value
 * @return {!proto.asset.Node} returns this
*/
proto.asset.Node.prototype.setExtraField = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.Node} returns this
 */
proto.asset.Node.prototype.clearExtraField = function() {
  return this.setExtraField(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.Node.prototype.hasExtraField = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Package.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Package.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Package} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Package.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
arch: jspb.Message.getFieldWithDefault(msg, 3, ""),
source: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Package}
 */
proto.asset.Package.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Package;
  return proto.asset.Package.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Package} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Package}
 */
proto.asset.Package.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArch(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Package.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Package.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Package} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Package.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArch();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.asset.Package.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Package} returns this
 */
proto.asset.Package.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.asset.Package.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Package} returns this
 */
proto.asset.Package.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string arch = 3;
 * @return {string}
 */
proto.asset.Package.prototype.getArch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Package} returns this
 */
proto.asset.Package.prototype.setArch = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string source = 4;
 * @return {string}
 */
proto.asset.Package.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Package} returns this
 */
proto.asset.Package.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.WindowsUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.WindowsUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.WindowsUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.WindowsUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
hotfixId: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
installedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
source: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.WindowsUpdate}
 */
proto.asset.WindowsUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.WindowsUpdate;
  return proto.asset.WindowsUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.WindowsUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.WindowsUpdate}
 */
proto.asset.WindowsUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHotfixId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInstalledAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.WindowsUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.WindowsUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.WindowsUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.WindowsUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHotfixId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInstalledAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string hotfix_id = 1;
 * @return {string}
 */
proto.asset.WindowsUpdate.prototype.getHotfixId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.WindowsUpdate} returns this
 */
proto.asset.WindowsUpdate.prototype.setHotfixId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.asset.WindowsUpdate.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.WindowsUpdate} returns this
 */
proto.asset.WindowsUpdate.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 installed_at = 3;
 * @return {number}
 */
proto.asset.WindowsUpdate.prototype.getInstalledAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.WindowsUpdate} returns this
 */
proto.asset.WindowsUpdate.prototype.setInstalledAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string source = 4;
 * @return {string}
 */
proto.asset.WindowsUpdate.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.WindowsUpdate} returns this
 */
proto.asset.WindowsUpdate.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
snapshotId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotRequest}
 */
proto.asset.SnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotRequest;
  return proto.asset.SnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotRequest}
 */
proto.asset.SnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.asset.SnapshotRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.SnapshotRequest} returns this
 */
proto.asset.SnapshotRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string snapshot_id = 2;
 * @return {string}
 */
proto.asset.SnapshotRequest.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.SnapshotRequest} returns this
 */
proto.asset.SnapshotRequest.prototype.setSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.GetListSnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.GetListSnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.GetListSnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListSnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
snapshotId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pagination: (f = msg.getPagination()) && asset_util_pb.RequestPagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.GetListSnapshotRequest}
 */
proto.asset.GetListSnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.GetListSnapshotRequest;
  return proto.asset.GetListSnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.GetListSnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.GetListSnapshotRequest}
 */
proto.asset.GetListSnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 3:
      var value = new asset_util_pb.RequestPagination;
      reader.readMessage(value,asset_util_pb.RequestPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.GetListSnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.GetListSnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.GetListSnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListSnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      asset_util_pb.RequestPagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.asset.GetListSnapshotRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListSnapshotRequest} returns this
 */
proto.asset.GetListSnapshotRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string snapshot_id = 2;
 * @return {string}
 */
proto.asset.GetListSnapshotRequest.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListSnapshotRequest} returns this
 */
proto.asset.GetListSnapshotRequest.prototype.setSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RequestPagination pagination = 3;
 * @return {?proto.asset.RequestPagination}
 */
proto.asset.GetListSnapshotRequest.prototype.getPagination = function() {
  return /** @type{?proto.asset.RequestPagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.RequestPagination, 3));
};


/**
 * @param {?proto.asset.RequestPagination|undefined} value
 * @return {!proto.asset.GetListSnapshotRequest} returns this
*/
proto.asset.GetListSnapshotRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.GetListSnapshotRequest} returns this
 */
proto.asset.GetListSnapshotRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.GetListSnapshotRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotNodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotNodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotNodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
snapshotId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nodeId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotNodeRequest}
 */
proto.asset.SnapshotNodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotNodeRequest;
  return proto.asset.SnapshotNodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotNodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotNodeRequest}
 */
proto.asset.SnapshotNodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotNodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotNodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotNodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNodeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.asset.SnapshotNodeRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.SnapshotNodeRequest} returns this
 */
proto.asset.SnapshotNodeRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string snapshot_id = 2;
 * @return {string}
 */
proto.asset.SnapshotNodeRequest.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.SnapshotNodeRequest} returns this
 */
proto.asset.SnapshotNodeRequest.prototype.setSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string node_id = 3;
 * @return {string}
 */
proto.asset.SnapshotNodeRequest.prototype.getNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.SnapshotNodeRequest} returns this
 */
proto.asset.SnapshotNodeRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.GetListSnapshotNodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.GetListSnapshotNodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListSnapshotNodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
snapshotId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nodeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pagination: (f = msg.getPagination()) && asset_util_pb.RequestPagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.GetListSnapshotNodeRequest}
 */
proto.asset.GetListSnapshotNodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.GetListSnapshotNodeRequest;
  return proto.asset.GetListSnapshotNodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.GetListSnapshotNodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.GetListSnapshotNodeRequest}
 */
proto.asset.GetListSnapshotNodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodeId(value);
      break;
    case 4:
      var value = new asset_util_pb.RequestPagination;
      reader.readMessage(value,asset_util_pb.RequestPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.GetListSnapshotNodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.GetListSnapshotNodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListSnapshotNodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNodeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      asset_util_pb.RequestPagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListSnapshotNodeRequest} returns this
 */
proto.asset.GetListSnapshotNodeRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string snapshot_id = 2;
 * @return {string}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.getSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListSnapshotNodeRequest} returns this
 */
proto.asset.GetListSnapshotNodeRequest.prototype.setSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string node_id = 3;
 * @return {string}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.getNodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListSnapshotNodeRequest} returns this
 */
proto.asset.GetListSnapshotNodeRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional RequestPagination pagination = 4;
 * @return {?proto.asset.RequestPagination}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.getPagination = function() {
  return /** @type{?proto.asset.RequestPagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.RequestPagination, 4));
};


/**
 * @param {?proto.asset.RequestPagination|undefined} value
 * @return {!proto.asset.GetListSnapshotNodeRequest} returns this
*/
proto.asset.GetListSnapshotNodeRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.GetListSnapshotNodeRequest} returns this
 */
proto.asset.GetListSnapshotNodeRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.GetListSnapshotNodeRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.SnapshotListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
snapshotListList: jspb.Message.toObjectList(msg.getSnapshotListList(),
    proto.asset.Snapshot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotListResponse}
 */
proto.asset.SnapshotListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotListResponse;
  return proto.asset.SnapshotListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotListResponse}
 */
proto.asset.SnapshotListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.Snapshot;
      reader.readMessage(value,proto.asset.Snapshot.deserializeBinaryFromReader);
      msg.addSnapshotList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getSnapshotListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.Snapshot.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.SnapshotListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.SnapshotListResponse} returns this
*/
proto.asset.SnapshotListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotListResponse} returns this
 */
proto.asset.SnapshotListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Snapshot snapshot_list = 2;
 * @return {!Array<!proto.asset.Snapshot>}
 */
proto.asset.SnapshotListResponse.prototype.getSnapshotListList = function() {
  return /** @type{!Array<!proto.asset.Snapshot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Snapshot, 2));
};


/**
 * @param {!Array<!proto.asset.Snapshot>} value
 * @return {!proto.asset.SnapshotListResponse} returns this
*/
proto.asset.SnapshotListResponse.prototype.setSnapshotListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.Snapshot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Snapshot}
 */
proto.asset.SnapshotListResponse.prototype.addSnapshotList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.Snapshot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.SnapshotListResponse} returns this
 */
proto.asset.SnapshotListResponse.prototype.clearSnapshotListList = function() {
  return this.setSnapshotListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
snapshot: (f = msg.getSnapshot()) && proto.asset.Snapshot.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotResponse}
 */
proto.asset.SnapshotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotResponse;
  return proto.asset.SnapshotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotResponse}
 */
proto.asset.SnapshotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.Snapshot;
      reader.readMessage(value,proto.asset.Snapshot.deserializeBinaryFromReader);
      msg.setSnapshot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapshot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.Snapshot.serializeBinaryToWriter
    );
  }
};


/**
 * optional Snapshot snapshot = 1;
 * @return {?proto.asset.Snapshot}
 */
proto.asset.SnapshotResponse.prototype.getSnapshot = function() {
  return /** @type{?proto.asset.Snapshot} */ (
    jspb.Message.getWrapperField(this, proto.asset.Snapshot, 1));
};


/**
 * @param {?proto.asset.Snapshot|undefined} value
 * @return {!proto.asset.SnapshotResponse} returns this
*/
proto.asset.SnapshotResponse.prototype.setSnapshot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotResponse} returns this
 */
proto.asset.SnapshotResponse.prototype.clearSnapshot = function() {
  return this.setSnapshot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotResponse.prototype.hasSnapshot = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.SnapshotNodeListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotNodeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotNodeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotNodeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
nodeListList: jspb.Message.toObjectList(msg.getNodeListList(),
    proto.asset.Node.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotNodeListResponse}
 */
proto.asset.SnapshotNodeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotNodeListResponse;
  return proto.asset.SnapshotNodeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotNodeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotNodeListResponse}
 */
proto.asset.SnapshotNodeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.Node;
      reader.readMessage(value,proto.asset.Node.deserializeBinaryFromReader);
      msg.addNodeList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotNodeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotNodeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotNodeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getNodeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.Node.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.SnapshotNodeListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.SnapshotNodeListResponse} returns this
*/
proto.asset.SnapshotNodeListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotNodeListResponse} returns this
 */
proto.asset.SnapshotNodeListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotNodeListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Node node_list = 2;
 * @return {!Array<!proto.asset.Node>}
 */
proto.asset.SnapshotNodeListResponse.prototype.getNodeListList = function() {
  return /** @type{!Array<!proto.asset.Node>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Node, 2));
};


/**
 * @param {!Array<!proto.asset.Node>} value
 * @return {!proto.asset.SnapshotNodeListResponse} returns this
*/
proto.asset.SnapshotNodeListResponse.prototype.setNodeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.Node=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Node}
 */
proto.asset.SnapshotNodeListResponse.prototype.addNodeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.Node, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.SnapshotNodeListResponse} returns this
 */
proto.asset.SnapshotNodeListResponse.prototype.clearNodeListList = function() {
  return this.setNodeListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotNodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotNodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotNodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
node: (f = msg.getNode()) && proto.asset.Node.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotNodeResponse}
 */
proto.asset.SnapshotNodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotNodeResponse;
  return proto.asset.SnapshotNodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotNodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotNodeResponse}
 */
proto.asset.SnapshotNodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.Node;
      reader.readMessage(value,proto.asset.Node.deserializeBinaryFromReader);
      msg.setNode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotNodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotNodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotNodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.Node.serializeBinaryToWriter
    );
  }
};


/**
 * optional Node node = 1;
 * @return {?proto.asset.Node}
 */
proto.asset.SnapshotNodeResponse.prototype.getNode = function() {
  return /** @type{?proto.asset.Node} */ (
    jspb.Message.getWrapperField(this, proto.asset.Node, 1));
};


/**
 * @param {?proto.asset.Node|undefined} value
 * @return {!proto.asset.SnapshotNodeResponse} returns this
*/
proto.asset.SnapshotNodeResponse.prototype.setNode = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotNodeResponse} returns this
 */
proto.asset.SnapshotNodeResponse.prototype.clearNode = function() {
  return this.setNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotNodeResponse.prototype.hasNode = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.SnapshotNodePackageListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotNodePackageListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotNodePackageListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodePackageListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
packageListList: jspb.Message.toObjectList(msg.getPackageListList(),
    proto.asset.Package.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotNodePackageListResponse}
 */
proto.asset.SnapshotNodePackageListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotNodePackageListResponse;
  return proto.asset.SnapshotNodePackageListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotNodePackageListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotNodePackageListResponse}
 */
proto.asset.SnapshotNodePackageListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.Package;
      reader.readMessage(value,proto.asset.Package.deserializeBinaryFromReader);
      msg.addPackageList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotNodePackageListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotNodePackageListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodePackageListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getPackageListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.Package.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.SnapshotNodePackageListResponse} returns this
*/
proto.asset.SnapshotNodePackageListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotNodePackageListResponse} returns this
 */
proto.asset.SnapshotNodePackageListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Package package_list = 2;
 * @return {!Array<!proto.asset.Package>}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.getPackageListList = function() {
  return /** @type{!Array<!proto.asset.Package>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Package, 2));
};


/**
 * @param {!Array<!proto.asset.Package>} value
 * @return {!proto.asset.SnapshotNodePackageListResponse} returns this
*/
proto.asset.SnapshotNodePackageListResponse.prototype.setPackageListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.Package=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Package}
 */
proto.asset.SnapshotNodePackageListResponse.prototype.addPackageList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.Package, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.SnapshotNodePackageListResponse} returns this
 */
proto.asset.SnapshotNodePackageListResponse.prototype.clearPackageListList = function() {
  return this.setPackageListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.SnapshotNodeWindowsUpdateListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.SnapshotNodeWindowsUpdateListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
windowsUpdateListList: jspb.Message.toObjectList(msg.getWindowsUpdateListList(),
    proto.asset.WindowsUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.SnapshotNodeWindowsUpdateListResponse;
  return proto.asset.SnapshotNodeWindowsUpdateListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.SnapshotNodeWindowsUpdateListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.WindowsUpdate;
      reader.readMessage(value,proto.asset.WindowsUpdate.deserializeBinaryFromReader);
      msg.addWindowsUpdateList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.SnapshotNodeWindowsUpdateListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.SnapshotNodeWindowsUpdateListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getWindowsUpdateListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.WindowsUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse} returns this
*/
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse} returns this
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated WindowsUpdate windows_update_list = 2;
 * @return {!Array<!proto.asset.WindowsUpdate>}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.getWindowsUpdateListList = function() {
  return /** @type{!Array<!proto.asset.WindowsUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.WindowsUpdate, 2));
};


/**
 * @param {!Array<!proto.asset.WindowsUpdate>} value
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse} returns this
*/
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.setWindowsUpdateListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.WindowsUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.WindowsUpdate}
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.addWindowsUpdateList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.WindowsUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.SnapshotNodeWindowsUpdateListResponse} returns this
 */
proto.asset.SnapshotNodeWindowsUpdateListResponse.prototype.clearWindowsUpdateListList = function() {
  return this.setWindowsUpdateListList([]);
};


goog.object.extend(exports, proto.asset);
